module.exports = __webpack_public_path__ + "static/media/cheque.c7b52d15.png";